type GridProps = Omit<React.ComponentPropsWithoutRef<'main'>, 'className'>;

export function MediaGrid(props: GridProps) {
    return (
        <div className="@container">
            <main
                className="grid w-full grid-cols-1 gap-5 @md:grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 @6xl:grid-cols-5"
                {...props}
            />
        </div>
    );
}
